import axios from "axios";
import store from "../redux/store";

const controller = new AbortController();

const generateNonce = (timestamp: string) => {
  const CryptoJS = require("crypto-js");

  const requestData = {}; // Adjust if actual data is available
  const hash = CryptoJS.SHA256(`${requestData}${timestamp}`);
  return hash.toString(CryptoJS.enc.Hex);
};

const PortalAxios = axios.create({
  baseURL: process.env.REACT_APP_CLIENT_PORTAL_API_URL_BASE,
  signal: controller.signal,
});

PortalAxios.interceptors.request.use(
  (config) => {
    const token = store.getState().authUser.userToken;
    const userId = store.getState().authUser.userId;
    const refreshToken = store.getState().authUser.refreshToken;

    const timestamp = new Date().toISOString();
    const nonce = generateNonce(timestamp);

    // Add required headers dynamically
    config.headers["X-Nonce"] = nonce;
    config.headers["X-Timestamp"] = timestamp;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["refreshtoken"] = refreshToken;
      config.headers["clientportal"] = "true";
      config.headers["userid"] = userId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

PortalAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
    }
    return Promise.reject(error);
  }
);

export default PortalAxios;
